import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=9114a81e&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9114a81e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9114a81e')) {
      api.createRecord('9114a81e', component.options)
    } else {
      api.reload('9114a81e', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=9114a81e&scoped=true&", function () {
      api.rerender('9114a81e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/sys/pagination/pagination.vue"
export default component.exports